import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environments';



@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  private BASE_URL = environment.apiUrl + 'api';

  constructor(private http: HttpClient) { }

  getProjects(): Observable<any> {
    const url = `${this.BASE_URL}/project/all`;
    return this.http.get<any>(url);
  }

  createProject(projectData: any): Observable<any> {
    const url = `${this.BASE_URL}/project/create`;
    return this.http.post<any>(url, projectData);
  }

  updateProject(projectId: string, projectData: any): Observable<any> {
    const url = `${this.BASE_URL}/project/update/${projectId}`;
    return this.http.put<any>(url, projectData);
  }

  deleteProject(projectId: string): Observable<any> {
    const url = `${this.BASE_URL}/project/delete/${projectId}`;
    return this.http.delete<any>(url);
  }
}